import { render, staticRenderFns } from "./unitDialog.vue?vue&type=template&id=8affb5b2&scoped=true"
import script from "./unitDialog.vue?vue&type=script&lang=js"
export * from "./unitDialog.vue?vue&type=script&lang=js"
import style0 from "./unitDialog.vue?vue&type=style&index=0&id=8affb5b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8affb5b2",
  null
  
)

export default component.exports